import { getImageUrl } from '@app/utils/getImageUrl';
import Box from '@redbubble/design-system/src/Box';
import Text from '@redbubble/design-system/src/Text';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import Image from 'next/legacy/image';
import styles from './ErrorCart.module.scss';

export const messages = defineMessages({
  unableToLoadCart: {
    defaultMessage: 'Sorry, we were unable to load your cart.',
  },
  tryAgainLater: {
    defaultMessage: 'Please try again later.',
  },
  emptyCartAlt: {
    defaultMessage: 'Empty Cart',
  },
});

export const ErrorCart = () => {
  const intl = useIntl();
  return (
    <Box className={styles.wrapper} justifyContent="center">
      <Text>{intl.formatMessage(messages.unableToLoadCart)}</Text>
      <Text>{intl.formatMessage(messages.tryAgainLater)}</Text>
      <Image
        alt={intl.formatMessage(messages.emptyCartAlt)}
        layout="fixed"
        src={getImageUrl('/icons/empty-cart.svg')}
        width={140}
        height={177}
      />
    </Box>
  );
};
